import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const VendorSchedules = () => {
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Get vendor_id from logged in user
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const vendor_id = user.id;

  useEffect(() => {
    if (!vendor_id) return;
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/vendor_schedules?vendor_id=${vendor_id}`)
      .then(res => res.json())
      .then(data => {
        setSchedules(data.schedules || []);
        setLoading(false);
      })
      .catch(() => {
        setSchedules([]);
        setLoading(false);
      });
  }, [vendor_id]);

  if (loading) return (
    <div style={styles.container}>
      <div style={styles.loader}>Loading schedules...</div>
    </div>
  );

  // Group schedules by service name
  const grouped = schedules.reduce((acc, entry) => {
    if (!acc[entry.service_name]) acc[entry.service_name] = [];
    acc[entry.service_name].push(entry);
    return acc;
  }, {});

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span style={styles.iconCircle}>
          <i className="fas fa-calendar-alt" style={styles.icon}></i>
        </span>
        <h2 style={styles.title}>Your Service Schedules</h2>
        <p style={styles.subtitle}>
          Review your scheduled services and update them as needed. All times are shown in US Eastern Time Zone.
        </p>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '18px' }}>
        <button
          style={styles.updateBtn}
          onClick={() => navigate('/vendorscheduleupdates')}
        >
          Update Schedule
        </button>
      </div>
      {schedules.length === 0 ? (
        <div style={styles.empty}>No schedules found.</div>
      ) : (
        <div style={styles.cardGrid}>
          {Object.entries(grouped).map(([service, entries], idx) => (
            <div key={idx} style={styles.card}>
              <h3 style={styles.cardTitle}>{service}</h3>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Detail</th>
                    <th style={styles.th}>Date</th>
                    <th style={styles.th}>Start Time</th>
                    <th style={styles.th}>End Time</th>
                    <th style={styles.th}>Hourly Rate</th>
                  </tr>
                </thead>
                <tbody>
                  {entries.map((entry, i) => (
                    <tr key={i} style={styles.tr}>
                      <td
                        style={{
                          ...styles.td,
                          background: '#fffde4',
                          color: '#4078c0',
                          fontWeight: 'bold',
                          borderRadius: '6px',
                          boxShadow: '0 1px 4px #ffe082',
                        }}
                      >
                        {entry.detail_name}
                      </td>
                      <td style={styles.td}>{entry.day_of_month}</td>
                      <td style={styles.td}>{entry.start_time}</td>
                      <td style={styles.td}>{entry.end_time}</td>
                      <td style={styles.td}>
                        {entry.hourly_rate !== undefined && entry.hourly_rate !== null && entry.hourly_rate !== ''
                          ? <span style={styles.rate}>${entry.hourly_rate}</span>
                          : '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '1100px',
    margin: '48px auto',
    padding: '40px',
    background: '#fff',
    borderRadius: '18px',
    boxShadow: '0 4px 24px rgba(141,110,54,0.10)',
  },
  loader: {
    textAlign: 'center',
    color: '#8d6e36',
    fontWeight: 'bold',
    fontSize: '1.2rem',
    padding: '40px 0',
  },
  header: {
    textAlign: 'center',
    marginBottom: '32px',
  },
  iconCircle: {
    background: '#4078c0',
    borderRadius: '50%',
    width: '54px',
    height: '54px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '12px',
    boxShadow: '0 2px 8px #b3c6e6',
  },
  icon: {
    color: '#fff',
    fontSize: '2rem',
    textShadow: '0 1px 4px #b3c6e6',
  },
  title: {
    color: '#4078c0',
    fontSize: '1.7rem',
    fontWeight: 'bold',
    marginBottom: '8px',
    marginTop: '0',
  },
  subtitle: {
    color: '#8d6e36',
    fontSize: '1.08rem',
    marginBottom: '0',
    marginTop: '0',
  },
  updateBtn: {
    background: '#8d6e36',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    padding: '12px 32px',
    fontWeight: 'bold',
    fontSize: '1.08rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px rgba(64,120,192,0.07)',
    marginLeft: '12px',
    marginTop: '0',
  },
  empty: {
    textAlign: 'center',
    color: '#888',
    fontSize: '1.1rem',
    marginTop: '32px',
  },
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
    gap: '28px',
    marginTop: '18px',
  },
  card: {
    background: '#f5f6fa',
    borderRadius: '14px',
    boxShadow: '0 4px 16px rgba(64,120,192,0.12)',
    border: '2px solid #e0cfa0',
    padding: '28px 18px',
    textAlign: 'center',
    marginBottom: '12px',
    transition: 'box-shadow 0.2s',
  },
  cardTitle: {
    fontSize: '1.18rem',
    fontWeight: 'bold',
    color: '#8d6e36',
    marginBottom: '14px',
    letterSpacing: '0.5px',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '8px',
    background: '#fff',
    borderRadius: '10px',
    overflow: 'hidden',
    boxShadow: '0 1px 8px rgba(64,120,192,0.07)',
  },
  th: {
    background: '#fffde4',
    color: '#8d6e36',
    padding: '12px',
    borderBottom: '2px solid #eee',
    fontWeight: 'bold',
    fontSize: '1.08rem',
    textAlign: 'center',
  },
  tr: {
    background: '#fff',
    transition: 'background 0.2s',
  },
  td: {
    padding: '12px',
    borderBottom: '1px solid #eee',
    textAlign: 'center',
    fontSize: '1.08rem',
    color: '#4078c0',
    fontWeight: 'bold',
    background: '#fff',
  },
  rate: {
    color: '#388e3c',
    fontWeight: 'bold',
    fontSize: '1.08rem',
    background: '#e8f5e9',
    padding: '4px 12px',
    borderRadius: '6px',
    boxShadow: '0 1px 4px #c8e6c9',
    display: 'inline-block',
  },
};

export default VendorSchedules;